module.exports = __webpack_public_path__ + "img/senderrand-runner-step-1.6dc12828.svg";